module.exports = __webpack_public_path__ + "static/img/Moch Fadli Rahmadi-close.f5981c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Moch Fadli Rahmadi-close.jpg
// module id = 7Rq8
// module chunks = 1